import PropTypes from "prop-types"
import JourneyAnswerShape from "./JourneyAnswerShape"

const JourneyQuestionShape = {
  questionText: PropTypes.string,
  answerSummaries: PropTypes.arrayOf(PropTypes.shape(JourneyAnswerShape)),
}

export default JourneyQuestionShape



// WEBPACK FOOTER //
// ./src/state/shapes/JourneyQuestionShape.js